<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ labelDate }}
            </h4>
            <div class="col-md-12" style="padding:0">
                <input 
                    id="date"
                    class="form-control" 
                    type="date" 
                    v-model="row.date"
                    v-on:change="onInputChange">
            </div>
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'CardDate',
    props: [
        'labelDate',
        'date',
    ],
    data(){
        return {
            row: {
                date: this.$props.date,
            },
        }
    },
    mounted() {},
    methods: {

        onInputChange(){
            const data = {
                date: this.row.date,
            }
            this.$emit('dateChange', data);
        },

    }
}
</script>
